import * as React from 'react';
import type { WrappedFieldArrayProps } from 'redux-form';

import { Button } from '@acceligentllc/storybook';

import type { MaterialGroupOption } from './MaterialGroupInput';
import MaterialGroupInput from './MaterialGroupInput';
import styles from './styles.module.scss';

export * from './MaterialGroupInput';

export interface MaterialGroupsOwnProps {
	groups: MaterialGroupOption[];
	selectedGroups: Record<string, true>;
}

type Props = MaterialGroupsOwnProps & WrappedFieldArrayProps<Nullable<string>>;

const MaterialGroups: React.FC<Props> = (props) => {
	const { fields, groups, selectedGroups } = props;

	const removeGroup = React.useCallback((index: number) => {
		fields.remove(index);
	}, [fields]);

	const addGroup = React.useCallback(() => {
		fields.push(null);
	}, [fields]);

	const renderField = React.useCallback((field: string, index: number) => {
		return (
			<MaterialGroupInput
				groups={groups}
				index={index}
				key={index}
				name={field}
				onRemove={removeGroup}
				selectedGroups={selectedGroups}
			/>
		);
	}, [groups, removeGroup, selectedGroups]);

	const canAddMore = React.useMemo(() => {
		return groups.some((_g) => !selectedGroups[_g.id]);
	}, [groups, selectedGroups]);

	return (
		<div className={styles.MaterialGroups}>
			{fields.map(renderField)}
			{canAddMore && (
				<Button
					icon="ActionPlusSmall"
					label="Add Material Group"
					onClick={addGroup}
					style="link"
				/>
			)}
		</div>
	);
};

export default React.memo(MaterialGroups);
